import React, { ChangeEvent, useState } from 'react';
import styles from './NewCriterionValue.module.scss';
import { useTranslate } from 'react-translate.ts';
import { ObjectSchema, StringSchema } from 'yup';
import useDebounce from '../../../../helpers/useDebounce';
import AdminInput from '../../input/AdminInput';
import XIcon from 'react-bootstrap-icons/dist/icons/x';

interface NewCriterionValueProps {
    onCreate: (value: string) => void;
    onClose: () => void;
}

interface Values {
    value: string;
}

const validationSchema = new ObjectSchema({
    value: new StringSchema().required().nonNullable(),
});

export default function NewCriterionValue(props: NewCriterionValueProps) {
    const { onCreate, onClose } = props;
    const [values, setValues] = useState<Values>({
        value: '',
    });
    const translate = useTranslate();
    const debounce = useDebounce();

    return (
        <div className={styles.wrapper}>
            <AdminInput
                value={values.value}
                onChange={handleChange(values)}
                placeholder={translate('Hodnota')}
            />
            <XIcon size={20} className={styles.close} onClick={onClose} />
        </div>
    );

    function handleChange(values: Values) {
        return async (event: ChangeEvent<HTMLInputElement>) => {
            const value = event.target.value;
            const newValues = { ...values, value };
            setValues(newValues);
            await debounce(create, newValues);
        };
    }

    async function create(values: Values) {
        if (values.value && (await validate(values))) {
            onCreate(values.value);
        }
    }

    async function validate(values: Values) {
        return await validationSchema.validate(values);
    }
}
